import api, { unwrap } from './client';

/* Importer le réalisé d'un fichier Excel ou d'un texte collé (2026-10-22). Une grille, deux entrées : `file` (.xlsx)
   ou `text` (cellules collées). `kind` : billing ou ca ; `year` : l'exercice CHOISI ; `sign` : positive ou negative,
   le signe des produits dans le fichier. */
export const getImportSettings = (tenantId) => unwrap(api.get(`/sales-billing-import/${tenantId}/settings`));
export const putImportSetting = (tenantId, kind, sign) => unwrap(api.put(`/sales-billing-import/${tenantId}/settings`, { kind, sign }));

const corps = ({ kind, year, sign, file, text }) => {
  const fd = new FormData();
  fd.append('kind', kind);
  fd.append('year', String(year));
  fd.append('sign', sign);
  if (file) fd.append('file', file);
  else if (text) fd.append('text', text);
  return fd;
};
const entete = { headers: { 'Content-Type': 'multipart/form-data' } };
// Ce que le chargement ferait, sans rien écrire.
export const previewRealiseImport = (tenantId, args) => unwrap(api.post(`/sales-billing-import/${tenantId}/preview`, corps(args), entete));
// Remplace les lignes de la nature et de l'exercice.
export const applyRealiseImport = (tenantId, args) => unwrap(api.post(`/sales-billing-import/${tenantId}/apply`, corps(args), entete));
